export const SentryDns = 'https://a207f09baba9448bb8a3bfe942a1de07@sentry.clario.co/32';

export const IgnoreErrors = ['Cannot read property \'pause\' of null', /^.*this._model.*$/, /^.*t._model.*$/, /^.*o._model.*$/, 'Unable to get property \'pause\' of undefined or null reference', /^.*e._model.*$/]

